"use client";

import parse, { domToReact, Element, DOMNode } from "html-react-parser";
import Link from "next/link";

export default function RichText({
	content,
	className,
}: {
	content: string;
	className?: string;
}) {
	if (typeof content !== "string" || !content.trim())
		return <p className="info info-alert">Texte invalide</p>;
	return (
		<div className={`${className} strapi-content`}>
			{parse(content, {
				replace: (domNode: DOMNode) => {
					//<A> links handling
					if (domNode instanceof Element && domNode.name === "a") {
						const href = domNode.attribs?.href;
						if (!href) return;

						const isInternal = href.startsWith("/");

						// petit cast ici pour calmer TS
						const children = domToReact(
							domNode.children as unknown as DOMNode[]
						);

						if (isInternal) {
							return (
								<Link
									href={href}
									className="text-primary font-bold hover:underline"
								>
									{children}
								</Link>
							);
						}

						return (
							<a
								href={href}
								target="_blank"
								rel="noopener noreferrer"
								className="text-primary font-bold hover:underline"
							>
								{children}
							</a>
						);
					}
				},
			})}
		</div>
	);
}
